import constants from 'constants/index'

const chipStatusLabel = (status) => {
  return (status && constants.audits.CHIP_STATUS_LABEL[status]) || 'Indefinido'
}

export default chipStatusLabel
